import React, { type ReactNode } from "react";
import styles from "./DocumentDescription.module.css";

type DocumentDescriptionPropsType = {
  inputValue: string;
  handleDescriptionInputChange: (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  errorElement: ReactNode;
};

const DocumentDescription = ({
  inputValue,
  handleDescriptionInputChange,
  errorElement,
}: DocumentDescriptionPropsType) => {
  const isTextTooLong = inputValue.length > 200;

  return (
    <label className={styles.label} htmlFor="documentDescription">
      <span className={styles.labelText}>Descripción del Documento</span>
      {errorElement}
      <textarea
        className={styles.textarea}
        name="documentDescription"
        id="documentDescription"
        value={inputValue}
        onChange={(e) => {
          handleDescriptionInputChange(e);
        }}
        placeholder="Un certificado de matrimonio es un documento oficial que acredita la unión legal entre dos personas..."
      />
      <span
        className={
          isTextTooLong ? styles.lengthCounterWarning : styles.lengthCounter
        }
      >
        {inputValue.length}/200
      </span>
    </label>
  );
};

export default DocumentDescription;
